import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _ctx.dialogTableVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogTableVisible) = $event)),
        title: "Custom detail"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogTableVisible = false)),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "Table",
                name: "table"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    data: _ctx.customs,
                    style: {"width":"100%"},
                    height: "300px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "id",
                        label: "Id",
                        "min-width": "10"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "text",
                        label: "Text",
                        "min-width": "10"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "imageLink",
                        label: "Image",
                        "min-width": "10"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "Name",
                        "min-width": "10"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "value",
                        label: "Value",
                        "min-width": "20"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Json",
                name: "json"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.customs), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}